import React, { useCallback, useState } from "react";
import Input from "components/foundation/Input/Input";
import {
  FindPasswordFormActions,
  FindPasswordFormStyle,
  FindPasswordModalStyle,
} from "./styles";
import Button from "components/foundation/Button";
import { useForm } from "react-hook-form";
import { debounce } from "lodash-es";
import { SendTemporaryPasswordParams } from "apis/data-contracts";
import { useSendTemporaryPassword } from "features/auth/hooks/mutations";
import Modal from "components/foundation/Modal/Modal";
import { EMAIL_VALIDATION } from "config/validation";
import AuthBottomSheetLayout from "../AuthBottomSheetLayout";

const FORM_ID = "find-password-form";

const FORM_FILED = {
  EMAIL: "email",
} as const;

const FindPasswordForm = () => {
  // 폼
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<SendTemporaryPasswordParams>({ mode: "onChange" });

  // 모달
  const [openModal, setOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");

  const sendTempPasswordMutation = useSendTemporaryPassword();
  /**
   * @description 비밀번호 찾기 폼 제출 이벤트 핸들러
   * @param form 비밀번호 찾기 폼
   */
  const onSubmit = async (form: SendTemporaryPasswordParams) => {
    sendTempPasswordMutation.mutate(
      {
        email: form.email,
      },
      {
        onSuccess: () => {
          setModalTitle(
            `임시 비밀번호가 ${form.email}으로 발송 완료 되었습니다.`,
          );
          setModalDescription(
            "임시 비밀번호로 로그인 이후 [MY INFORMATION]에서 비밀번호 변경 가능합니다.",
          );
          setOpenModal(true);
        },
        onError: (res: any) => {
          if (res.status === 404) {
            setModalTitle(`비밀번호 찾기 오류`);
            setModalDescription("존재하지 않는 계정입니다.");
          } else {
            setModalTitle(`이메일 발송 실패`);
            setModalDescription(
              "이메일 주소 확인이 필요합니다. 이메일 발송 실패 반복시, 관리자에게 문의 바랍니다.",
            );
          }

          setOpenModal(true);
        },
      },
    );
  };
  const debouncedSubmit = useCallback(
    debounce(onSubmit, 1000, {
      leading: true,
      trailing: false,
    }),
    [],
  );

  return (
    <>
      <AuthBottomSheetLayout bottomWithKeyboard={-60}>
        <FindPasswordFormStyle
          id={FORM_ID}
          onSubmit={handleSubmit(debouncedSubmit)}
        >
          <Input
            type="email"
            placeholder="이메일을 입력해 주세요"
            {...register(FORM_FILED.EMAIL, {
              required: "이메일을 입력하세요",
              pattern: {
                value: EMAIL_VALIDATION,
                message: "이메일 형식으로 입력이 필요합니다.",
              },
            })}
            errorMessage={errors.email?.message}
          />
        </FindPasswordFormStyle>

        <FindPasswordFormActions>
          <Button
            form={FORM_ID}
            size="large"
            type="submit"
            disabled={!isValid}
            fill
          >
            임시 비밀번호 발송
          </Button>
        </FindPasswordFormActions>
      </AuthBottomSheetLayout>

      <Modal.Root open={openModal} onOpenChange={setOpenModal}>
        <FindPasswordModalStyle title={modalTitle} confirm>
          {modalDescription}
        </FindPasswordModalStyle>
      </Modal.Root>
    </>
  );
};

export default FindPasswordForm;
